<div class="container" *ngIf="client && initialized">
  <app-sidebar [authService]="authService" [routes]="routes"></app-sidebar>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>
